import React, {Fragment} from 'react';
import autobind from 'autobind-decorator';
import {Col, FormControl} from 'react-bootstrap';

import {BaseTableFilter} from "../../Common/Tables/BaseTableFilter";
import {service as SampleEventPhaseService} from "../../../Services/SampleEventPhaseService";
import {service as ProcedureService} from "../../../Services/ProcedureService";

export class EventsTableFilter extends BaseTableFilter {
    constructor(props) {
        super(props);

        this.setInitialState({
            phases: [],
            phaseId: "",
            procedures: [],
            procedureId: "",
            textFilter: ""
        });
    }

    @autobind
    loadData() {
        super.loadData();

        SampleEventPhaseService.Get().then((x) => {
            this.setState({
                phases: x.result
            });
        });

        ProcedureService.Get().then((x) => {
            this.setState({
                procedures: x.result
            });
        });
    }

    @autobind
    generateFilters() {
        let filters = [];

        if(this.state.phaseId != "") {
            filters.push({
                code: 'phaseId',
                isSet: true,
                logic: (x) => x.sampleEventPhaseId == this.state.phaseId
            });
        }

        if(this.state.procedureId != "") {
            filters.push({
                code: 'procedureId',
                isSet: true,
                logic: (x) => x.procedureId == this.state.procedureId
            });
        }

        if(this.state.textFilter != "") {
            filters.push({
                code: 'textFilter',
                isSet: true,
                logic: (x) => x.name.toUpperCase().includes(this.state.textFilter.toUpperCase()) ||
                    !!x?.ConservationActionSampleEvents
                        ?.map(x => x.ConservationAction?.ContextNodeDetails?.name?.toUpperCase())
                        .filter(x => x.includes(this.state.textFilter.toUpperCase()))
                        .length
            });
        }

        this.updateFilters(filters);
    }

    @autobind
    updateSelect(event, type) {
        this.setState({ [type]: event.target.value }, () => {
            this.generateFilters();
        });
    }

    @autobind
    updateTextFilter(event) {
        this.setState({ textFilter: event.target.value }, () => {
            this.generateFilters();
        });
    }

    @autobind
    _render() {
        return <Fragment>
            <Col xs={3} key="phase" className="d-flex align-items-center">
                { this.state.phases.length > 1 ?
                    <FormControl
                        style={{width: '100%'}}
                        as="select"
                        placeholder="Select Phase"
                        value={this.state.phaseId}
                        onChange={(e) => this.updateSelect(e, 'phaseId')}
                    >
                        <option value="" key="">Select Phase</option>
                        {
                            this.state.phases.map((x) =>
                                <option key={x.sampleEventPhaseId} value={x.sampleEventPhaseId}>{x.name}</option>
                            )
                        }
                    </FormControl>
                    : null }
            </Col>
            <Col xs={3} key="procedure" className="d-flex align-items-center">
                { this.state.procedures.length > 1 ?
                    <FormControl
                        style={{width: '100%'}}
                        as="select"
                        placeholder="Select Procedure"
                        value={this.state.procedureId}
                        onChange={(e) => this.updateSelect(e, 'procedureId')}
                    >
                        <option value="" key="">Select Procedure</option>
                        {
                            this.state.procedures.map((x) =>
                                <option key={x.procedureId} value={x.procedureId}>{x.name}</option>
                            )
                        }
                    </FormControl>
                    : null }
            </Col>
            <Col xs={3} key="text" className="d-flex align-items-center">
                <FormControl
                    style={{width: '100%'}}
                    type="text"
                    autoCorrect="off"
                    autoCapitalize="off"
                    autoComplete="off"
                    spellCheck={false}
                    value={this.state.textFilter}
                    placeholder="Search"
                    onChange={this.updateTextFilter}
                />
            </Col>
        </Fragment>;
    }
}
